export const DEMO_PAGE_ROUTE = "/demo";
export const SIGNUP_PAGE_ROUTE = "/sign-up";
export const SIGNIN_PAGE_ROUTE = "/sign-in";
export const NOTES_ROUTE = "/notes";
